<template>
  <div class="reset-pw">
    <v-container fluid>
    <h2 class="my-3">Reset your password</h2>

    <h4 class="my-3" color="#ed831a" v-if='!emailVerified'>Your email address has not been verified. You must verify your email address before your password can be reset. If you do not have access to your email or password, you will need to create a new account.</h4>

      <v-card v-if='emailVerified'>
        <v-container>
          <div class="mx-3">
            <h4>Account email address:</h4>
            <p>{{ email }}</p>
            <p class="mt-3 mb-1">Click to send a password reset email:</p>
            <v-btn v-on:click="resetPw" class="mx-0" color="primary">Reset</v-btn>

            <p v-if='emailSent' class="mt-3"><em>Message sent. Please check your email.</em></p>
            <p v-if='errorMessage' color="#ed831a">An error occurred: {{ errorMessage }}</p>
            
            <!-- <v-divider class="mt-4 mb-1"></v-divider> -->

            <!-- <v-btn to="login" class="mx-0" flat color="secondary">Go to login</v-btn> -->
            <!-- <v-btn to="signup" class="mx-0" flat color="secondary">Create a new account</v-btn> -->
            <!-- <span>or go back to <router-link to="/login">login</router-link></span> -->
            <!-- <p class="my-3">Or go back to login?</p> -->
          <!-- <v-btn to="login">Go to login</v-btn> -->
          </div>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// import axios from 'axios'
import firebase from 'firebase'

export default {
  name: 'ResetPassword',
  data: function () {
    return {
      emailVerified: '',
      // email: '',
      emailSent: false,
      errorMessage: ''
    }
  },
  created () {
    // console.log('Firebase currentUser...')
    // console.log(firebase.auth().currentUser)
    // force a user state refresh
    firebase.auth().currentUser.getIdToken(true)
    .then((idToken) => {
      this.$set(this.$data, 'emailVerified', firebase.auth().currentUser.emailVerified)
      // this.$set(this.$data, 'email', firebase.auth().currentUser.email)
    })
    // console.log(firebase.auth().currentUser.email)
  },
  computed: {
    // a computed getter
    email: () => {
      // `this` points to the vm instance
      return firebase.auth().currentUser.email
    }
  },
  methods: {
    resetPw: function () {
      // var context = this
      // console.log(context)
      // console.log('Password reset method not implemented yet.')
      // console.log(this)
      console.log('email: ' + this.email)
      // console.log('email: ' + this.email)
      var auth = firebase.auth()

      auth.sendPasswordResetEmail(this.email)
      .then(() => {
        // Email sent message
        this.$set(this.$data, 'emailSent', true)
      })
      .catch((error) => {
        // An error happened
        console.log('Error: ' + error)
        this.$set(this.$data, 'errorMessage', error)
      })
      .then(this.$router.push('reset-password-confirmation'))
    }
  }
}
</script>

<style scoped>
  .signUp {
    margin-top: 40px;
  }
  input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
  }
  button {
    margin-top: 10px;
    width: 10%;
    cursor: pointer;
  }
  span {
    display: block;
    margin-top: 20px;
    font-size: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/User/ResetPassword.vue